<template>
<div id="messageBar" v-bind:class="{ visible: messages.length > 0}">

	<div class="message" v-for="message in messages">
		{{ message.text }}
	</div>

</div>
</template>


<script>
    export default {
        props: {
	        type: {},
	        startMessages: {}
	    },
	    data: function() {

            return {
                text: null,
                messages: []
            }
        },
	    created: function() {

	    	var self = this;

    		if(self.startMessages != null) {

    			setTimeout(function(){

    				self.toggle(self.startMessages);

    			}, 300);
    		}

	    	bus.$on('notify', function (text) {

	    		console.log('got notify from bus');

	    		var notification = {'id': new Date().getTime(), 'text': text }

	    		console.log(notification);

	    		self.toggle(notification);

			})


	    },
	    methods: {

	    	toggle: function(notification) {

	    		var self = this;

	    		self.messages.push(notification);

	    		setTimeout(function(){

					self.messages = _.filter(self.messages, function(message) { return message.id != notification.id });

	    		}.bind(self), 6000);


	    	}

	    },


    }
</script>